import { TimestampFormatter } from '@ta-interaktiv/react-publication-info';
import FeedbackMessage from '@ta-interaktiv/react-feedback-message';
import ShareButtons from '@ta-interaktiv/react-share-buttons';
import CopyrightNotice from '@ta-interaktiv/react-copyright-notice';
import { UserFeedback } from '@ta-interaktiv/react-user-feedback';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css';
import React, { useEffect, useState } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles-module_feedbackAndShares__1R_UW .ui.message.feedback-message {\n  padding: 0;\n  background-color: transparent; }\n\n@media screen and (max-width: 599px) {\n  .styles-module_creditsRow__1adda .column {\n    border-top: 1px solid var(--strong-transparent-black); } }\n";
var styles = {"feedbackAndShares":"styles-module_feedbackAndShares__1R_UW","creditsRow":"styles-module_creditsRow__1adda"};
styleInject(css);

var PortfolioTeaser = function (_a) {
    var mediaName = _a.mediaName;
    var domain = mediaName || parseHostname().publicationName;
    return (React.createElement("div", { className: 'centered row portfolio' },
        React.createElement("div", { className: 'column' },
            React.createElement("a", { href: "https://interaktiv." + domain + ".ch", className: 'ui fluid image' },
                React.createElement("img", { src: 'https://interaktiv.tagesanzeiger.ch/inline-teaser.gif', className: 'portfolio-teaser', alt: 'Die besten Arbeiten des Interaktiv-Teams: Zur Sammlung' })))));
};

function Footer(_a) {
    var articleId = _a.articleId, call = _a.call, className = _a.className, credits = _a.credits, displayPrivacyPolicyLink = _a.displayPrivacyPolicyLink, fullMediaName = _a.fullMediaName, inverted = _a.inverted, locale = _a.locale, mailTo = _a.mailTo, mediaName = _a.mediaName, project = _a.project, question = _a.question, _b = _a.hidePortfolioTeaser, hidePortfolioTeaser = _b === void 0 ? false : _b, _c = _a.hideUserFeedback, hideUserFeedback = _c === void 0 ? false : _c, year = _a.year;
    var copyrightNoticeProps = {
        displayPrivacyPolicyLink: displayPrivacyPolicyLink,
        fullMediaName: fullMediaName,
        inverted: inverted,
        locale: locale,
        mediaName: mediaName,
        year: year
    };
    var portfolioTeaserProps = {
        mediaName: mediaName
    };
    var feedbackMessageProps = {
        call: call,
        inverted: inverted,
        locale: locale,
        mailTo: mailTo,
        project: project,
        question: question
    };
    var shareButtonProps = {
        articleId: articleId,
        inverted: inverted
    };
    var userFeedbackProps = {
        articleId: articleId,
        inverted: inverted,
        locale: locale
    };
    var segmentClass = inverted ? 'inverted basic' : 'grey';
    var tableClass = inverted ? 'inverted' : '';
    var _d = useState((window.project && window.project.buildTimestamp) || 0), publicationDate = _d[0], setPublicationDate = _d[1];
    var domain = mediaName || parseHostname().publicationName;
    useEffect(function () {
        window
            .fetch("https://m." + domain + ".ch/api/articles/" + articleId)
            .then(function (response) {
            if (response.ok) {
                return response.json();
            }
            throw new Error(response.status + ": " + response.statusText);
        })
            .then(function (data) {
            setPublicationDate(data.article.first_published_at);
        })
            .catch(function (e) {
            console.groupCollapsed('Footer');
            console.warn('API Access failed: ', e);
            console.groupEnd();
        });
    }, [articleId, domain]);
    return (React.createElement("footer", { className: "ui vertical secondary segment standalone-footer " + segmentClass + " " + styles.footer },
        React.createElement("div", { className: 'ui container' },
            React.createElement("div", { className: 'ui two column stackable grid' },
                !hideUserFeedback && (React.createElement("div", { className: 'centered row user-feedback' },
                    React.createElement("div", { className: 'column' },
                        React.createElement(UserFeedback, __assign({}, userFeedbackProps))))),
                !hidePortfolioTeaser && (React.createElement(PortfolioTeaser, __assign({}, portfolioTeaserProps))),
                React.createElement("div", { className: "row credits " + styles.creditsRow },
                    React.createElement("div", { className: 'column' },
                        React.createElement("table", { className: "ui small very basic " + tableClass + " definition infographic table" },
                            React.createElement("tbody", null,
                                credits.map(function (row, rowIndex) { return (React.createElement("tr", { key: "credits-" + rowIndex, className: 'top aligned' }, row.map(function (cell, cellIndex) { return (React.createElement("td", { key: "credits-" + rowIndex + "-" + cellIndex, dangerouslySetInnerHTML: { __html: cell } })); }))); }),
                                publicationDate > 0 && (React.createElement("tr", null,
                                    React.createElement("td", null, "Ver\u00F6ffentlicht"),
                                    React.createElement("td", null,
                                        React.createElement(TimestampFormatter, { locale: locale, timestamp: publicationDate }))))))),
                    React.createElement("div", { className: "column " + styles.feedbackAndShares },
                        React.createElement(FeedbackMessage, __assign({}, feedbackMessageProps)),
                        React.createElement("div", { className: 'ui fluid share container' },
                            React.createElement(ShareButtons, __assign({}, shareButtonProps, { displayType: 'vertical buttons', className: 'basic' }))))),
                React.createElement("div", { className: 'centered row copyright' },
                    React.createElement("div", { className: 'column' },
                        React.createElement("div", { className: 'ui fluid copyright container' },
                            React.createElement(CopyrightNotice, __assign({}, copyrightNoticeProps)))))))));
}

export default Footer;
export { Footer };
//# sourceMappingURL=index.js.map
